


export type AuthenticationTypes = "BANKUSER"| "ADMIN" | "FİRMA YETKİLİSİ"| "MÜŞTERİ TEMSİLCİSİ" | "BAYİ/MÜŞTERİ" |"ALTBAYİ" ;

export enum UserOperationTypes {
    "Müşteri Tanımla" =1,
    "Ödeme Al" =2,
    "Serbest Ödeme Al" =3,
    "Ödeme Linki Gönder" =4,
    "Ödeme İptali" =5,
    "Ödeme İadesi" =6,
    "İşlem Listesi" =7,
    "Banka Seçimi" =8,
    "Erp Entegrasyonu" =9,
    "Erp Bakiye Sorgula" =10,
    "Kullanıcı İşlemleri" =11,
    "Müşteri Listesi"=12,
    "Komisyon Seçimi"=13
}
